export default {
  "content": "<path d=\"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M250.26 166.05L256 288l5.73-121.95a5.74 5.74 0 00-5.79-6 5.74 5.74 0 00-5.68 6z\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M256 367.91a20 20 0 1120-20 20 20 0 01-20 20z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};